import React, { useState, useEffect } from "react";
import Layout from "containers/Layout";
import "react-dropdown/style.css";
import { Headersubfull } from "components/GenericComponent/HeaderSubFull/headersubfull";
import { useSelector, useDispatch } from "react-redux";
import { TableDanhSach } from "./TableDanhSach";
import { SearchBarDesktop } from "./SearchBarDesktop";
import StoreApi from "../../../service/phanQuyenApi";
import { BtnThemMoi } from "./ThemMoi/BtnThemMoi";
import BanHangTraGopApi from "../../../service/banHangTraGopApi";
import configsRole from "utils/configsRole";
import LayoutV2 from "containers/LayoutV2";

export const CauHinhGoiTraGop = () => {
  const initPhanQuyen = {
    banhangtragop_cauhinhsanpham: false,
  };
  const [phanQuyen, setPhanQuyen] = useState(initPhanQuyen);

  const LoadPhanQuyen = () => {
    BanHangTraGopApi.getAllQuyen().then((response) => {
      if (response.status === 200) {
        var sRoleDanhSach = response.data.find(
          (e) =>
            e.ModuleCode.toUpperCase() ===
            configsRole.sRole.banhangtragop_cauhinhsanpham.toUpperCase()
        );
        if (sRoleDanhSach != null) {
          setPhanQuyen({
            ...phanQuyen,
            banhangtragop_cauhinhsanpham: true,
          });
        } else {
          setPhanQuyen({
            ...phanQuyen,
            banhangtragop_cauhinhsanpham: false,
          });
        }
      }
    });
  };

  useEffect(() => {
    document.title = "Cấu hình trả góp | Phần mềm quản lý cầm đồ Morman";
    LoadPhanQuyen();
  }, []);
  return (
    <LayoutV2>
      {phanQuyen.banhangtragop_cauhinhsanpham === true ? (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          <i className="fas fa-donate font-menu"></i>
                          <h1 className="text-info-home">Cấu hình trả góp</h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card border-light mb-1 hidden-mobile-main show-table-main card-v2">
                  <div className="card-body card-body-v2">
                    <SearchBarDesktop />
                  </div>
                </div>
                {/* <div className="iconbutton-new  show-table-main">
                  <div className="row">
                    <div className="col-sm-12 col-md-9">
                      <BtnThemMoi />
                    </div>
                    <div className="col-sm-12 col-md-3 d-flex just-end"></div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          <TableDanhSach />
        </div>
      ) : (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          <i className="fas fa-donate font-menu"></i>
                          <h1 className="text-info-home">Cấu hình trả góp</h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span
            style={{
              textAlign: "center",
              color: "red",
              display: "flex",
              justifyContent: "center",
            }}
          >
            Bạn không có quyền truy cập chức năng này.
          </span>
        </div>
      )}
    </LayoutV2>
  );
};
